<div class="title">
  <span class="title estricta uppercase"> Painel de Vendas </span>
</div>



<app-card class="density-lower">

  <form [formGroup]="form" class="density-mat-form-3" (keydown.enter)="$event.preventDefault(); filter()">
    <span class="estricta uppercase"> Filtros </span>
    <br />
    <br />

    <div class="filters">
          <span class="form-field">
            <label> Ponto de Venda: </label>
            <mat-form-field appearance="outline" class="density-mat-form-3">
              <mat-select formControlName="identifierCode" data-cy="dealer" placeholder="Selecione">
                <mat-option *ngFor="let dealerOption of dealerOptions" [value]="dealerOption.value"> {{dealerOption.key}}
                </mat-option>
              </mat-select>

              <mat-error *ngIf="form.get('identifierCode').hasError('required') && form.get('identifierCode').touched" data-cy="dealerRequiredError">
                <strong class="error"> Campo obrigatório </strong>
              </mat-error>
            </mat-form-field>
          </span>

        </div>


    <div class="filters">


      <div class="group1">
        <app-custom-datapicker label="Data Inicial:" formControlName="startDate" [control]="form.get('startDate')"
          datacy="startSalesDate">
          <mat-error *ngIf="form.hasError('startGreaterThanEnd')" class="fix-error-position" data-cy="startSalesDateErrorStartGreaterThanEnd">
            <strong class="error"> Data Inicial não pode ser maior que data final </strong>
          </mat-error>
          <mat-error *ngIf="form.hasError('periodGreaterThan')" class="fix-error-position" data-cy="startSalesDateErrorPeriodGreaterThan30Days">
            <strong class="error"> Não é possível efetuar pesquisa com mais de 30 dias  </strong>
          </mat-error>
        </app-custom-datapicker>


      </div>

      <div class="group1">

        <app-custom-datapicker label="Data Final:" formControlName="endDate" [control]="form.get('endDate')" datacy="endSalesDate"/>


      </div>
    </div>

    <div class="button-filters">
      <app-button type="submit" width="100%" datacy="button-clean" (onClick)="cleanForm()" datacy="button-clear" [disabled]="!hasAccessToAnyDealer">
        <span style="font-size: 16px;"> Limpar </span>
      </app-button>

      <app-button type="submit" width="100%" color="primary" [disabled]="!form.valid || loading || !hasPermissionToRead || !hasAccessToAnyDealer" [loading]="loading"
        (onClick)="filter()" datacy="button-search">
        <span style="font-size: 16px;"> Pesquisar </span>
      </app-button>
    </div>
  </form>
</app-card>

<div class="reports-split">

  <app-card class="table-wrapper force-height">
    <div>
      <h3> Vendas </h3>
    </div>

    <table *ngIf="sales.length > 0" class="table">
      <thead>
        <tr>
          <th>Formas de acesso</th>
          <th>Quantidade</th>
          <th *ngIf="hasPermissionToViewDetails">Visualizar</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let sale of sales">
          <td>{{ sale.plataform }}</td>
          <td>{{ sale.salesCount}}</td>
          <td class="action-column" *ngIf="hasPermissionToViewDetails">
            <button (click)="viewDetails(sale)" class="buttons-read" mat-icon-button [attr.data-cy]="'buttonview' + sale.plataform">
              <mat-icon>visibility</mat-icon>
              </button>
          </td>
        </tr>
        <tr class="aggregate">
          <td> Total </td>
          <td>{{ aggregateSales(sales) }}</td>
          <td *ngIf="hasPermissionToViewDetails"></td>
        </tr>
      </tbody>
    </table>

    <div *ngIf="sales.length == 0">Clique no botão "buscar" para visualizar os dados.</div>
  </app-card>

  <app-card>
    <div class="force-height">
      <usage-graph-chart/>
    </div>
  </app-card>

</div>
